import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "src/app/core/services/auth.service";
import { ModelDto, ModelPerformanceDto, ModelResultDto } from "./model-api.interfaces";
import { environment } from "src/environments/environment";
import { Guid } from "guid-typescript";

@Injectable({
    providedIn: 'root'
})

export class ModelApiService {
    controllerUrl: string = 'model';

    private readonly authService: AuthService = inject(AuthService);
    private readonly httpClient: HttpClient = inject(HttpClient);

    getAll(): Observable<ModelDto[]> {
        const options = {
            headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
        };

        return this.httpClient.get<ModelDto[]>(`${environment.analysisApiUrl}/${this.controllerUrl}`, options);
    }

    getById(id: number): Observable<ModelDto> {
        const options = {
            headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
            params: new HttpParams().set('modelId', id.toString())
        };

        return this.httpClient.get<ModelDto>(`${environment.analysisApiUrl}/${this.controllerUrl}/GetModelById`, options);
    }

    getModelPerformanceByModelId(modelId: number): Observable<ModelPerformanceDto[]> {
        const options = {
            headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
            params: new HttpParams().set('modelId', modelId.toString())
        };

        return this.httpClient.get<ModelPerformanceDto[]>(`${environment.analysisApiUrl}/${this.controllerUrl}/GetModelPerformanceByModelId`, options);
    }

    getModelResultsByModelAndAnalysisId(modelId: number, analysisId: Guid): Observable<ModelResultDto[]> {
        const options = {
            headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
            params: new HttpParams()
                .set('modelId', modelId.toString())
                .set('analysisId', analysisId.toString())
        };

        return this.httpClient.get<ModelResultDto[]>(`${environment.analysisApiUrl}/${this.controllerUrl}/GetModelResultsByModelAndAnalysisId`, options);
    }
}